export function numberSpinner() {
	var spinner = document.querySelectorAll(".number-spinner");

	spinner.forEach(function(spinner) {
		var input = spinner.querySelector('input'), action;

		spinner.querySelectorAll('button').forEach(function(btn) {
			btn.addEventListener("mousedown", function(){
				action = setInterval(function(){
					input.value = parseInt(input.value) + parseInt(btn.getAttribute('data-dir'));
				}, 85);
			});

			btn.addEventListener("mouseup", function(){
				clearInterval(action);
			});
		});
	});
}
